<template>
  <div class="component-leadlovers">
    <div class="breadcrumbs d-flex align-items-center font-weight-bold mb-9">
      <router-link :to="{ name: 'home' }" class="text-secondary"
        >Início</router-link
      >
      <i class="icon-angle-right text-secondary mx-3"></i>
      <router-link :to="{ name: 'tools' }" class="text-secondary">
        Ferramentas
      </router-link>
      <i class="icon-angle-right text-secondary mx-3"></i>
      <router-link
        :to="{ name: 'tools-email-marketing' }"
        class="text-secondary"
      >
        E-mail marketing
      </router-link>
      <i class="icon-angle-right text-secondary mx-3"></i>
      Leadlovers
    </div>

    <h6 class="d-none d-lg-block">LeadLovers</h6>
    <div class="row align-items-center mb-5 pt-6">
      <div class="col-lg-3 mb-3">
        <div class="d-flex align-items-center">
          <div class="mr-5">Integrações</div>
          <button
            class="btn btn-sm btn-outline-primary btn-square-sm p-5"
            @click="dispatch"
          >
            <i class="icon-refresh-ccw" />
          </button>
        </div>
      </div>
      <div class="col-lg-9">
        <div class="d-flex algn-items-center justify-content-end">
          <search-filter
            class="mr-3 flex-fill"
            placeholder="Pesquisar conta"
            @search="searching"
            :showFilters="false"
            :showResultsDropdown="false"
          />
          <button
            type="button"
            class="btn btn-primary px-5 px-lg-6"
            @click="modal = true"
          >
            <span class="d-none d-lg-inline">
              Adicionar
            </span>
            <i class="icon-plus d-lg-none lead"></i>
          </button>
        </div>
      </div>
    </div>
    <div v-if="loading" class="text-center">
      <b-spinner variant="primary" />
    </div>
    <div v-else>
      <div
        v-if="!integrationList.length"
        class="container centralize-row text-center pt-5"
      >
        <div class="row justify-content-center">
          <div class="col-lg-5">
            <img
              class="d-block mb-9 mx-auto"
              src="@/assets/images/home/welcome.svg"
            />
            <h5>Você ainda não adicionou nenhuma integração</h5>
            <div class="text-secondary mb-5">
              Clique no botão acima para cadastrar
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <!-- Desktop area -->
        <data-table
          class="d-none d-lg-block"
          :data="integrationList"
          :columns="columns"
          columnsFr="1fr 0.8fr 0.3fr 0.3fr"
        >
          <template #default="{item}">
            <small class="d-flex align-items-center">
              {{ formatLongText(item.description) }}
            </small>
            <small class="d-flex align-items-center">
              {{ formatLongText(item.token) }}
            </small>
            <small class="d-flex align-items-center">
              <strong :class="item.status ? 'text-success' : 'text-danger'">{{
                item.status ? "Ativo" : "Inativo"
              }}</strong>
            </small>
            <div class="d-flex align-items-center justify-content-end">
              <actions-dropdown
                :left="false"
                :right="true"
                :actions="getActions(item)"
                @edit="edit(item)"
                @delete="submitDelete(item)"
                @change-status="changeStatus(item)"
              />
            </div>
          </template>
        </data-table>
        <!-- Desktop area -->
        <!-- Mobile area -->
        <data-table
          class="d-lg-none"
          :columns="mobileColumns"
          :data="integrationList"
          :firstColumnFr="2"
          :lastColumnFr="0.5"
        >
          <template #default="{ item }">
            <div class="d-flex flex-column text-left pl-3 py-5 text-truncate">
              <small class="d-flex align-items-center">
                <strong class="mr-3">Descrição: </strong>
                {{ item.description }}
              </small>
              <small class="d-flex align-items-center">
                <strong class="mr-3">Token: </strong>
                {{ item.token }}
              </small>
              <small class="d-flex align-items-center">
                <strong class="mr-3">Status: </strong>
                <strong :class="item.status ? 'text-success' : 'text-danger'">{{
                  item.status ? "Ativo" : "Inativo"
                }}</strong>
              </small>
            </div>
            <div class="d-flex justify-content-end">
              <actions-dropdown
                :left="false"
                :right="true"
                :actions="getActions(item)"
                @edit="edit(item)"
                @delete="submitDelete(item)"
                @change-status="changeStatus(item)"
              />
            </div>
          </template>
        </data-table>
        <!-- Mobile area -->
      </div>
      <div
        v-if="integrationList.length"
        class="d-flex justify-content-center pt-3"
      >
        <paginator :pagination="pagination" @on-update="dispatch" />
      </div>
    </div>
    <lead-lovers-modal
      v-model="modal"
      :integrationToEdit="integrationToEdit"
      @clear-edit="integrationToEdit = null"
      @update-list="dispatch"
      @loading="loading = true"
    />
  </div>
</template>
<script>
import LeadLoversModal from "@/components/tools/modals/LeadLovers.vue";
import { mapState } from "vuex";
export default {
  components: {
    LeadLoversModal
  },
  data() {
    return {
      loading: false,
      integrationToEdit: null,
      integration: "leadlovers",
      modal: false,
      columns: ["Descrição", "Token", "Status", ""],
      mobileColumns: ["", ""]
    };
  },
  mounted() {
    this.$store.commit("integration/setIntegration", this.integration);
    this.dispatch();
  },
  computed: {
    ...mapState("integration", ["integrationList", "pagination", "typeEvents"]),
    eventsOptions() {
      let options = [...this.typeEvents];
      options.unshift({ id: "", name: "Todos os eventos" });
      return options;
    }
  },
  methods: {
    searching(v) {
      this.loading = true;
      this.$store
        .dispatch("integration/getIntegration", { search: v })
        .finally(() => (this.loading = false));
    },
    formatLongText(txt) {
      if (txt) {
        return txt.length > 20 ? `${txt.slice(0, 20)}...` : `${txt}`;
      }
      return "-";
    },
    getActions(item) {
      return [
        {
          text: item.status ? "Desativar" : "Ativar",
          class: item.status ? "text-danger" : "text-success",
          icon: "icon-power",
          confirmation: {
            enable: false,
            text: ""
          },
          event: "change-status"
        },
        {
          text: "Editar",
          class: "",
          icon: "fa-solid fa-pen",
          confirmation: {
            enable: false,
            text: ""
          },
          event: "edit"
        },
        {
          text: "Remover",
          class: "text-danger",
          icon: "icon-trash",
          confirmation: {
            enable: true,
            text: "Deseja mesmo remover esta integração?"
          },
          event: "delete"
        }
      ];
    },
    dispatch() {
      this.loading = true;
      this.$store
        .dispatch("integration/getIntegration")
        .catch(error => {
          this.$message.error("Não foi possível carregar as integrações");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    changeStatus(item) {
      let data = item;
      data.status = !item.status;
      this.$store
        .dispatch("integration/putIntegration", data)
        .then(() => {
          this.$message.success(
            `Integração ${data.status ? "ativada" : "desativada"}`
          );
        })
        .catch(error => {
          this.$message.error(
            "Não foi possível alterar o status da integração"
          );
        });
    },
    submitDelete(v) {
      this.loading = true;
      this.$store
        .dispatch("integration/deleteIntegration", v.id)
        .then(() => {
          this.dispatch();
          this.$message.success("Integração removida");
        })
        .catch(error => {
          if (error.response && error.response.data.detail) {
            this.$message.error(error.response.data.detail);
          } else {
            this.$message.error("Não foi possível deletar a integração");
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    edit(v) {
      this.integrationToEdit = v;
      this.modal = true;
    }
  }
};
</script>
